import { LoanPaymentHeaderComponent } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/LoanPaymentHeaderComponent';
import { withPaymentMethodCardWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodWrapper';
import { BnplPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/Bnpl/entities/PaymentMethod/BnplPaymentMethod';

interface BnplPaymentMethodCardProps {
  paymentMethodEntity: BnplPaymentMethod;
}

export const BnplPaymentMethodCard = ({ paymentMethodEntity }: BnplPaymentMethodCardProps) => {
  return <LoanPaymentHeaderComponent paymentMethodEntity={paymentMethodEntity} hasLenders />;
};

export const BnplPaymentMethodCardWithWrapper = withPaymentMethodCardWrapper(BnplPaymentMethodCard);
